import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  // Skip adding auth header for login and public registration endpoints
  const publicPaths = [
    'login',
    'register/create',
    'document/upload',
    'application/status',
    'application/resendStatus',
    'application/verifyStatus',
  ];

  const isPublic = publicPaths.some((path) => req.url.includes(path));

  if (token && !isPublic) {
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Token expired / Unauthorized
      if (error.status === 401) {
        authService.logout();
      }

      return throwError(() => error);
    }),
  );
};
